import React, {useEffect, useRef, useState} from "react";
import Icon from "../../Icon/Icon";
import {KoerberInput, KoerberInputIconWrapper, KoerberInputWrapper} from "./Input.style";
import {KoerberContainedLabel} from "../Label/ContainedLabel.style";

const Input = (props) => {
    const { labelText, disabled, name, id, value, noIcon, errorMessage, required, invalid, errorHandler, placeholder, className, icon, validate, inputRef, type, changeHandler, iconHandler, onKeyPress } = props;

    const containerRef = useRef(null);
    const [height, setHeight] = useState(0);
    const [showHideState, setshowHideState] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        setHeight(containerRef.current.offsetHeight);
        setshowHideState(noIcon);
    }, []);

    useEffect(() => {
        setError(invalid);
    }, [invalid]);

    const handleChange = (event) => {
        if(!!errorHandler) setError(errorHandler(event));
        if(!!changeHandler) changeHandler(event);
        if(validate) validate(event.target.value);
    };

    const handleShowHideState = (event) => {
        if(!!iconHandler) {
            iconHandler(event);
            return;
        }

        if(!!error) return;
        setshowHideState(!showHideState);
    }
    
    return (
        <KoerberInputWrapper className={className} ref={containerRef} >
            {!noIcon && <KoerberInputIconWrapper
                disabled={disabled} 
                containerHeight={height} 
                showHideState={showHideState} 
                onClick={handleShowHideState}>
                {!noIcon && <Icon icon={icon ? icon : error ? "info" : "eye"} />}
            </KoerberInputIconWrapper>}
            <KoerberInput 
                className={`${error ? 'error' : ''} p-regular ${className ? className : ''}`} 
                name={name}
                id={id}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={disabled}
                type={type ? type : showHideState ? "text" : "password"}
                value={value} 
                required={required}
                onKeyPress={onKeyPress}
                ref={inputRef}
                autocomplete="do-not-autofill"
            />
            {labelText && <KoerberContainedLabel 
                className="label-medium" 
                htmlFor={name} 
                required={required}
                disabled={disabled}>
                {labelText}{required ? ' *' : ''}
            </KoerberContainedLabel>}
            {errorMessage && <span className="label-small">{errorMessage || "Error"}</span>}
        </KoerberInputWrapper>
    )
}

export default Input;